import {
  combineReducers
} from 'redux-immutable';
import { routerReducer } from 'react-router-redux';
import UsersReducer from './usersReducer';
import ProductsReducer from './productsReducer';
import CartReducer from './cartReducer';
import PaymentsReducer from './paymentsReducer';
import OrdersReducer from './ordersReducer';

const rootReducer = combineReducers({
  users: UsersReducer,
  products: ProductsReducer,
  routing: routerReducer,
  cart: CartReducer,
  payments: PaymentsReducer,
  orders: OrdersReducer
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js